/** A frame is only a hint. The backend independently verifies the customer's required action. */
export async function verifyRequiredFundingAction(client, provider, operationId) {
    const controller = new AbortController();
    const unsubscribe = client.onDispose(() => controller.abort());
    try {
        const connection = await provider.getConnection({ skipKyc: true });
        if (controller.signal.aborted || !connection.ok || connection.value.status !== 'active')
            return;
        const credentials = provider.getCredentials?.();
        if (!credentials?.ok)
            return;
        await client.verifyRequiredAction(operationId, connection.value.customer.id, credentials.value.accessToken, controller.signal);
    }
    catch {
        if (!controller.signal.aborted)
            client.observeFunnel?.({
                stage: 'customer_verification',
                outcome: 'error',
                errorCode: 'verification_pending',
                operationId,
            });
    }
    finally {
        unsubscribe();
    }
}
